import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearStore, loginUser } from '../../store/actions/general';
import { statusIsGood, statusIsUnauthorized } from '../../utils';
import useCurrentUser from '../../hooks/useCurrentUser';

export const RequireLogin = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = useCurrentUser();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const rawResp = await fetch('/api/auth/current-user');

        if (statusIsUnauthorized(rawResp.status)) {
          dispatch(clearStore());
          navigate('/login', { replace: true, state: { redirect: location } });
        } else if (statusIsGood(rawResp.status)) {
          const resp = await rawResp.json();

          dispatch(
            loginUser({
              email: resp.user.email,
              firstName: resp.user.firstName,
              lastName: resp.user.lastName,
              isActive: resp.user.isActive,
            }),
          );
        }
      } catch (error) {
        dispatch(clearStore());
        navigate('/login', { replace: true, state: { redirect: location } });
      }
    };
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!currentUser?.isActive) {
    return null;
  }
  return children;
};
